import React from "react";

const Modal = ({ type = "small", title, children, backdropStyle = {}, onDismiss = () => {} }) => {
  let modalContainerClass = "bg-white dark:bg-black rounded-lg z-[1] animate-zoom-in";
  if (type === "small") modalContainerClass += " max-w-[480px] min-w-[300px]";
  if (type === "md") modalContainerClass += " max-w-[90%] min-w-[600px]";
  if (type === "xl") modalContainerClass += " max-w-[85%] min-w-[85%]";

  return (
    <div className='fixed top-0 left-0 w-full h-screen flex items-center justify-center'>
      <div className='fixed w-full h-screen bg-[rgba(0,0,0,0.7)]' style={backdropStyle} onClick={onDismiss}></div>
      <div className={modalContainerClass}>
        {title && <header className='py-4 px-3 font-semibold border-b border-black-200 text-black dark:border-black-800 dark:text-white'>{title}</header>}
        {children}
      </div>
    </div>
  );
};

export default Modal;
